import { partnerForgotCode } from '@/lib/api/partner-portal/partner-portal-api'
import { Turnstile } from '@marsidev/react-turnstile'
import { useRef, useState } from 'react'
import { MdArrowBack, MdCheckCircle, MdEmail } from 'react-icons/md'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY || ''

export default function PartnerForgotCodePage() {
    const [email, setEmail] = useState('')
    const [turnstileToken, setTurnstileToken] = useState('')
    const [loading, setLoading] = useState(false)
    const [sent, setSent] = useState(false)
    const turnstileRef = useRef<any>(null)
    const navigate = useNavigate()

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()

        if (!email.trim()) {
            toast.warning('Digite seu e-mail.')
            return
        }

        if (TURNSTILE_SITE_KEY && !turnstileToken) {
            toast.warning('Aguarde a verificação de segurança.')
            return
        }

        setLoading(true)

        const response = await partnerForgotCode(email.trim(), turnstileToken)

        if (response.success) {
            setSent(true)
        } else {
            toast.error(response.error || 'Erro ao enviar e-mail.')
            turnstileRef.current?.reset()
            setTurnstileToken('')
        }

        setLoading(false)
    }

    if (sent) {
        return (
            <div className="min-h-screen bg-base-200 flex items-center justify-center p-4" data-theme="atendimento">
                <div className="card w-full max-w-md bg-base-100 shadow-xl">
                    <div className="card-body text-center">
                        <div className="flex justify-center mb-4">
                            <div className="w-16 h-16 rounded-full bg-success/10 flex items-center justify-center">
                                <MdCheckCircle className="text-success text-3xl" />
                            </div>
                        </div>
                        <h2 className="text-xl font-bold text-base-content">
                            E-mail Enviado
                        </h2>
                        <p className="text-base-content/60 mt-2">
                            Se o e-mail estiver cadastrado, enviaremos o código
                            de acesso.
                        </p>
                        <button
                            type="button"
                            className="btn btn-secondary mt-6"
                            onClick={() => navigate('/partner')}
                        >
                            <MdArrowBack className="text-lg" />
                            Voltar ao login
                        </button>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="min-h-screen bg-base-200 flex items-center justify-center p-4" data-theme="atendimento">
            <div className="card w-full !max-w-md bg-base-100 shadow-xl">
                <div className="card-body">
                    <div className="text-center mb-6">
                        <div className="flex justify-center mb-4">
                            <div className="w-16 h-16 rounded-full bg-secondary/10 flex items-center justify-center">
                                <MdEmail className="text-secondary text-3xl" />
                            </div>
                        </div>
                        <h1 className="text-2xl font-bold text-base-content">
                            Recuperar Código
                        </h1>
                        <p className="text-base-content/60 mt-1">
                            Informe seu e-mail para receber o código de acesso
                        </p>
                    </div>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div className="form-control">
                            <label className="label">
                                <span className="label-text font-medium">
                                    E-mail
                                </span>
                            </label>
                            <input
                                type="email"
                                placeholder="seu@email.com"
                                className="input input-bordered w-full"
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                disabled={loading}
                                autoFocus
                            />
                        </div>

                        {TURNSTILE_SITE_KEY && (
                            <div className="flex justify-center">
                                <Turnstile
                                    ref={turnstileRef}
                                    siteKey={TURNSTILE_SITE_KEY}
                                    onSuccess={setTurnstileToken}
                                    onError={() => setTurnstileToken('')}
                                    onExpire={() => setTurnstileToken('')}
                                    options={{ theme: 'light' }}
                                />
                            </div>
                        )}

                        <button
                            type="submit"
                            className="btn btn-secondary w-full"
                            disabled={loading || (!!TURNSTILE_SITE_KEY && !turnstileToken)}
                        >
                            {loading ? (
                                <span className="loading loading-spinner loading-sm" />
                            ) : (
                                'Enviar'
                            )}
                        </button>
                    </form>

                    <div className="divider my-2" />

                    <div className="text-center">
                        <button
                            type="button"
                            className="btn btn-ghost btn-sm text-secondary"
                            onClick={() => navigate('/partner')}
                        >
                            <MdArrowBack className="text-lg" />
                            Voltar ao login
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
